import { TrendScore } from "./Enums";

export class WeightCalcTrendGroup {

    fluctuateToValue: boolean;
    trend: TrendScore;

    static parse(json: any): WeightCalcTrendGroup {
        if (json) {
            const wctd = new WeightCalcTrendGroup();

            wctd.fluctuateToValue = json.fluctuateToValue;
            wctd.trend = TrendScore[<string>json.trend];

            return wctd;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<WeightCalcTrendGroup> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(WeightCalcTrendGroup.parse(j));

        return arr;
    }
}

export class TrendValue {
    value: number;
    change: number;
    score: string;
    excluded: boolean;

    static parse(json: any): TrendValue {
        if (json) {
            const tv = new TrendValue();

            tv.value = json.value;
            tv.change = json.change;
            tv.score = json.score;
            tv.excluded = json.excluded;

            return tv;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<TrendValue> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(TrendValue.parse(j));

        return arr;
    }
}

export class WeightYear {
    id: string;
    available: boolean;
    year: number;
    revenue: number;
    sde: number;
    ebitda: number
    revenueTrendValue: TrendValue;
    sdeTrendValue: TrendValue;

    static parse(json: any): WeightYear {
        if (json) {
            const wy = new WeightYear();

            wy.id = json.id;
            wy.available = json.available;
            wy.year = json.year;
            wy.revenue = json.revenue;
            wy.sde = json.sde;
            wy.ebitda = json.ebitda;
            wy.revenueTrendValue = json.revenueTrendValue;
            wy.sdeTrendValue = json.sdeTrendValue;

            if (json.revenueTrendValue)
                wy.revenueTrendValue = TrendValue.parse(json.revenueTrendValue);

            if (json.sdeTrendValue)
                wy.sdeTrendValue = TrendValue.parse(json.sdeTrendValue);

            return wy;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<WeightYear> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(WeightYear.parse(j));

        return arr;
    }

}